import axios from "axios";

import SingleCheckPDFExporter from "./SingleCheckPDFExporter";
import NetRxLogo from '../assets/NetRxLogo.png';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export default async function SingleCheckPdfExportWrapper(pmid, accessToken, setIsLoadingFunction) {
    setIsLoadingFunction(true);

    try {
        const response = await axios.get(`api/Check/GetSingleCheckPdfExport`, {
            params: { PMID: pmid },
            headers: { Authorization: `Bearer ${accessToken}` }
        })

        var ctx = document.getElementById('hiddenCanvasForSingleCheckPdf').getContext('2d');
        var img = new Image();
        img.onload = () => {
            ctx.drawImage(img, 0, 0);

            const data = response.data

            // Generate filename with datetime
            const now = new Date();
            const dateTimeString = `${now.getFullYear()}-${
              now.getMonth() + 1
            }-${now.getDate()}_${now.getHours()}${now.getMinutes()}`;
            let pdfFileName = `REMITADVICE_${dateTimeString}`;

            let docDefinition = SingleCheckPDFExporter(data);
            if (docDefinition) {
                pdfMake.vfs = pdfFonts;
                pdfMake.createPdf(docDefinition).download(pdfFileName);
                setIsLoadingFunction(false)
            }
        }
        img.src = NetRxLogo;
    } catch (e) {
        setIsLoadingFunction(false);
        console.log(e);
    }
}